// import Home from "../pages/home";
import AddMachine from "../pages/addMachine";
import Details from "../pages/details";
import AttendanceDetails from "../pages/attendanceDetails";
import Attendance from "../pages/attendance";
import Employees from "../pages/employees";
import EmployeeDetails from "../pages/employeeDetails";
import MachinesDetails from "../pages/machineDetails";
import EmployeeAdd from "../pages/employeeAdd";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "../pages/login";
import { ToastContainer } from "react-toastify";
import Machines from "../pages/machines";
import Home from "../pages/home";

const Navigation = () => {
    return (
        <BrowserRouter>
            <ToastContainer autoClose={1500} />
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Home />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route
                    path="/attendance-details/:data"
                    element={<AttendanceDetails />}
                />
                <Route path="/employees" element={<Employees />} />
                <Route
                    path="/employee-details/:id"
                    element={<EmployeeDetails />}
                />
                <Route path="/machines" element={<Machines />} />
                <Route
                    path="/machine-details/:data"
                    element={<MachinesDetails />}
                />
                <Route path="/add-machine" element={<AddMachine />} />
                <Route path="/attendance/:data" element={<Details />} />
                <Route path="/employee-add" element={<EmployeeAdd />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Navigation;
